var exports = {
  "Nr": "CrosspostCommunityCard.module__card___emxnak",
  "Uo": "CrosspostCommunityCard.module__sheetCard___emxnak",
  "vK": "CrosspostCommunityCard.module__banner___emxnak",
  "_e": "CrosspostCommunityCard.module__bannerImage___emxnak",
  "Dw": "CrosspostCommunityCard.module__bannerScrim___emxnak",
  "Kk": "CrosspostCommunityCard.module__icon___emxnak",
  "rf": "CrosspostCommunityCard.module__body___emxnak",
  "$": "CrosspostCommunityCard.module__titleRow___emxnak",
  "fh": "CrosspostCommunityCard.module__nameText___emxnak",
  "h_": "CrosspostCommunityCard.module__description___emxnak",
  "qr": "CrosspostCommunityCard.module__footer___emxnak",
  "dJ": "CrosspostCommunityCard.module__stat___emxnak",
  "gW": "CrosspostCommunityCard.module__statDot___emxnak",
  "rR": "CrosspostCommunityCard.module__statDotOnline___emxnak" + " " + "CrosspostCommunityCard.module__statDot___emxnak",
  "rb": "CrosspostCommunityCard.module__statDotMembers___emxnak" + " " + "CrosspostCommunityCard.module__statDot___emxnak",
  "KA": "CrosspostCommunityCard.module__statText___emxnak",
  "lm": "CrosspostCommunityCard.module__notice___emxnak",
  "XI": "CrosspostCommunityCard.module__action___emxnak",
  "Lq": "CrosspostCommunityCard.module__loading___emxnak",
};

module.exports = exports;
